import { APPSERVER_API_PREFIX } from '../axios/axios.constants';
import { getAxiosInstance } from '../axios/axios.utilities';
import { useAxiosInstance } from '../reactQuery/ApiProvider.context';
import type { AxiosInstance } from 'axios';

async function executeGraphQL<TData, TVariables>(
  axiosInstance: AxiosInstance,
  document: string,
  variables?: TVariables,
): Promise<TData> {
  const response = await axiosInstance.request<{ data: TData; errors?: { message: string }[] }>({
    method: 'post',
    url: `${APPSERVER_API_PREFIX}/graphql`,
    data: { query: document, variables },
  });

  if (response.data.errors?.length) {
    throw new Error(response.data.errors.map((e) => e.message).join('\n'));
  }

  return response.data.data;
}

export function useGraphQLFetcher<TData, TVariables>(document: string): (variables?: TVariables) => Promise<TData> {
  const axiosInstance = useAxiosInstance();
  return (variables?: TVariables) => executeGraphQL<TData, TVariables>(axiosInstance, document, variables);
}

export function graphQLRequest<TData, TVariables>(document: string, variables?: TVariables): Promise<TData> {
  return executeGraphQL<TData, TVariables>(getAxiosInstance(), document, variables);
}
